import React from 'react'

import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'

const LangDropdown = ({
    label, 
    value, 
    onChange, 
    languages,
}) => {
    return  <FormControl fullWidth>
                <InputLabel required >
                    {label}
                </InputLabel>
                <Select 
                    
                    label={label}
                    value={value} 
                    onChange={onChange} 
                    sx={{backgroundColor: 'white'}}
                >
                    {languages.map((l,i)=> 
                        <MenuItem key={i} value={l.lang}>
                            {l.language}
                        </MenuItem>
                    )}
                </Select>
            </FormControl >
}

export default LangDropdown